// extracted by mini-css-extract-plugin
export default {"colDiv":"TribalSupport_colDiv__ALzA2","detailClass":"TribalSupport_detailClass__L+tTp","btnDiv":"TribalSupport_btnDiv__eFqul","btnClass":"TribalSupport_btnClass__pmRS+"};